import { Grid, Skeleton, Typography, Box, Chip } from '@mui/material';

interface SurveyResponseAnswersProps {
    response: any;
    loading: boolean;
}

export const SurveyResponseAnswers = ({
    response,
    loading,
}: SurveyResponseAnswersProps) => {
    if (loading) {
        return (
            <Grid container spacing={2}>
                {[...Array(4)].map((_, index) => (
                    <Grid item xs={12} key={index}>
                        <Skeleton variant="rectangular" height={80} />
                    </Grid>
                ))}
            </Grid>
        );
    }

    if (
        !response ||
        !response.surveyResponseAnswers ||
        response.surveyResponseAnswers.length === 0
    ) {
        return (
            <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                    No hay respuestas registradas
                </Typography>
            </Box>
        );
    }

    return (
        <Grid container spacing={3}>
            {response.surveyResponseAnswers.map(
                (answer: any, index: number) => (
                    <Grid item xs={12} key={answer.id || index}>
                        <Box
                            sx={{
                                p: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1,
                                backgroundColor: 'background.paper',
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                gutterBottom
                            >
                                Pregunta {index + 1}
                                {answer.question?.required && (
                                    <Chip
                                        label="Obligatoria"
                                        size="small"
                                        color="error"
                                        sx={{ ml: 1 }}
                                    />
                                )}
                            </Typography>
                            <Typography
                                variant="body1"
                                fontWeight="medium"
                                gutterBottom
                            >
                                {answer.question?.description ||
                                    'Pregunta sin texto'}
                            </Typography>
                            <Box sx={{ mt: 2 }}>
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                >
                                    Respuesta:
                                </Typography>
                                <Box sx={{ mt: 0.5 }}>
                                    <Typography variant="body2">
                                        {answer.answerText ||
                                            answer.answer?.description ||
                                            answer.answer?.label ||
                                            '-'}
                                    </Typography>
                                </Box>
                            </Box>
                            {answer.why && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                    >
                                        Razón:
                                    </Typography>
                                    <Box sx={{ mt: 0.5 }}>
                                        <Typography variant="body2">
                                            {answer.why}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                )
            )}
        </Grid>
    );
};
